/* eslint-disable array-callback-return */

import React from 'react';
import { EditorState, Modifier } from 'draft-js';
import {
  createEmptySelectionState,
  contentStateWithInsertedText,
  getContentStateWithAppliedEntity,
  inserNewBlockToContentState,
} from 'Shared/utils/draftJsHelpers';

import Gif from 'Shared/components/DraftEditor/components/GifComponent/GifComponent';

const GIF_ANCHOR = ' ';
const GIF_ENTITY_TYPE = 'GIF';

function removeGif(editorState, entityKey) {
  const contentState = editorState.getCurrentContent();
  const contentBlocks = contentState.getBlocksAsArray();
  let entityInfo = {};
  contentBlocks.map(contentBlock => {
    let selectedEntity = null;
    contentBlock.findEntityRanges(
      character => {
        if (character.getEntity() === entityKey) {
          selectedEntity = {
            blockKey: contentBlock.getKey(),
          };
          return true;
        }
        return false;
      },
      (start, end) => {
        entityInfo = { ...selectedEntity, start, end };
      }
    );
  });

  const selectionForReplaceAnchor = createEmptySelectionState(entityInfo.blockKey, entityInfo.start, entityInfo.end);
  const contentStateWithReplacedAnchor = Modifier.removeRange(contentState, selectionForReplaceAnchor);

  return EditorState.push(editorState, contentStateWithReplacedAnchor, 'apply-entity');
}

const gifPlugin = {
  decorators: [
    {
      strategy: (contentBlock, callback, contentState) => {
        contentBlock.findEntityRanges(character => {
          const entityKey = character.getEntity();
          return entityKey !== null && contentState.getEntity(entityKey).getType() === GIF_ENTITY_TYPE;
        }, callback);
      },
      component: props => <Gif {...props} onRemoveGif={removeGif} />,
    },
  ],
};

function createGifEntity(editorState, entityData) {
  const contentState = editorState.getCurrentContent();
  const contentStateWithNewBlock = inserNewBlockToContentState(contentState, 'gif-block');
  const lastBlockKey = contentStateWithNewBlock.getLastBlock().getKey();
  const selectionForAnchor = createEmptySelectionState(lastBlockKey, 0, 0);
  const contenstStateWithAnchor = contentStateWithInsertedText(
    contentStateWithNewBlock,
    selectionForAnchor,
    `${GIF_ANCHOR} `
  );
  const selectionStateForEntity = createEmptySelectionState(lastBlockKey, 0, 0 + GIF_ANCHOR.length);
  const contentStateWithCreatedEntity = getContentStateWithAppliedEntity(
    contenstStateWithAnchor,
    selectionStateForEntity,
    GIF_ENTITY_TYPE,
    entityData
  );

  const contentStateWithEmptyString = inserNewBlockToContentState(contentStateWithCreatedEntity);
  return EditorState.push(editorState, contentStateWithEmptyString);
}

function updateEntitysOfGifBeforeSend(editorState) {
  let contentState = editorState.getCurrentContent();
  const contentBlocks = contentState.getBlocksAsArray();
  contentBlocks.map(contentBlock => {
    const characterList = contentBlock.getCharacterList();
    characterList.map(character => {
      const entityKey = character.getEntity();
      if (!entityKey) return;
      const entity = contentState.getEntity(entityKey);
      const entityType = entity.getType();
      if (entityType === GIF_ENTITY_TYPE) {
        const entityData = entity.getData();
        contentState = contentState.replaceEntityData(entityKey, { ...entityData, canDeleteGif: false });
      }
    });
  });

  return EditorState.push(editorState, contentState, 'apply-entity');
}

function enrichEditorStateByGif(editorState, gif, entityData = {}) {
  if (!gif) return editorState;

  const editorStateWithEntity = createGifEntity(editorState, {
    src: gif.fixed_width?.url,
    canDeleteGif: true,
    ...entityData,
  });
  return EditorState.moveFocusToEnd(editorStateWithEntity);
}

export { enrichEditorStateByGif, gifPlugin, removeGif, updateEntitysOfGifBeforeSend };
